const HIDE_DELAY_MS = 500;

/** @type {Map<HTMLElement, { target: HTMLElement, hideTimer: ReturnType<typeof setTimeout> | null }>} */
const triggerRegistry = new Map();

let outsideClickBound = false;

function resolveTriggerTarget(selector) {
  if (!selector) return null;

  const normalized = selector.trim();
  if (!normalized) return null;

  if (normalized.startsWith('#') || normalized.startsWith('.')) {
    return document.querySelector(normalized);
  }

  return document.getElementById(normalized) || document.querySelector(`#${CSS.escape(normalized)}`);
}

function isHoveringZone(trigger, target) {
  return trigger.matches(':hover') || target.matches(':hover');
}

function activate(trigger, target) {
  const state = triggerRegistry.get(trigger);
  if (!state) return;

  clearTimeout(state.hideTimer);
  state.hideTimer = null;

  target.classList.add('active');
  trigger.classList.add('active');
  trigger.setAttribute('aria-expanded', 'true');
}

function deactivate(trigger, target) {
  const state = triggerRegistry.get(trigger);
  if (!state) return;

  clearTimeout(state.hideTimer);
  state.hideTimer = null;

  target.classList.remove('active');
  trigger.classList.remove('active');
  trigger.setAttribute('aria-expanded', 'false');
}

function scheduleDeactivate(trigger, target) {
  const state = triggerRegistry.get(trigger);
  if (!state) return;

  clearTimeout(state.hideTimer);
  state.hideTimer = setTimeout(() => {
    if (isHoveringZone(trigger, target)) return;
    deactivate(trigger, target);
  }, HIDE_DELAY_MS);
}

function bindOutsideClick() {
  if (outsideClickBound) return;
  outsideClickBound = true;

  document.addEventListener('click', (event) => {
    triggerRegistry.forEach((state, trigger) => {
      const { target } = state;
      if (!trigger.contains(/** @type {Node} */ (event.target)) && !target.contains(/** @type {Node} */ (event.target))) {
        deactivate(trigger, target);
      }
    });
  });
}

function setupTriggerButton(trigger) {
  if (trigger.dataset.fcdTriggerInit === 'true') return;

  const target = resolveTriggerTarget(trigger.getAttribute('data-fcd-target'));
  if (!target) return;

  trigger.dataset.fcdTriggerInit = 'true';
  trigger.setAttribute('type', 'button');
  trigger.setAttribute('aria-expanded', 'false');

  triggerRegistry.set(trigger, { target, hideTimer: null });

  trigger.addEventListener('mouseenter', () => activate(trigger, target));
  trigger.addEventListener('mouseleave', () => scheduleDeactivate(trigger, target));
  target.addEventListener('mouseenter', () => activate(trigger, target));
  target.addEventListener('mouseleave', () => scheduleDeactivate(trigger, target));

  trigger.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (target.classList.contains('active')) {
      deactivate(trigger, target);
    } else {
      activate(trigger, target);
    }
  });
}

function initFcdTriggerButtons() {
  bindOutsideClick();
  document.querySelectorAll('.fcd-trigger-button[data-fcd-target]').forEach(setupTriggerButton);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFcdTriggerButtons);
} else {
  initFcdTriggerButtons();
}

document.addEventListener('shopify:section:load', initFcdTriggerButtons);
